/**
 * getActiveDeadlinesCount - Hjelpefunksjon for å telle aktive frister
 * Brukes av alle moduler med fristhåndtering
 */
export function getActiveDeadlinesCount(moduleId) {
  try {
    const stored = localStorage.getItem(`${moduleId}_frister`);
    if (!stored) return 0;
    const frister = JSON.parse(stored);
    const now = new Date();
    return frister.filter(f => {
      const deadline = new Date(f.date);
      const daysUntil = Math.ceil((deadline - now) / (1000 * 60 * 60 * 24));
      return daysUntil > 0 && daysUntil <= 30;
    }).length;
  } catch {
    return 0;
  }
}

/**
 * formatDate - Standard datoformatering
 */
export function formatDate(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('nb-NO', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}

/**
 * getDaysUntil - Beregn dager til frist
 */
export function getDaysUntil(date) {
  const now = new Date();
  const deadline = new Date(date);
  return Math.ceil((deadline - now) / (1000 * 60 * 60 * 24));
}

/**
 * getDeadlineStatus - Returner status basert på dager til frist
 */
export function getDeadlineStatus(daysUntil) {
  if (daysUntil <= 0) return 'expired';
  if (daysUntil <= 7) return 'urgent';
  if (daysUntil <= 14) return 'warning';
  return 'normal';
}
